import { SDK_DOMAIN } from '../../constants';
import { getLocationPath, setAddEventListener } from '../../helpers';

const CardRegiComplete = {
  render: async () => {
    return `
      <div>
        <a id="connect_pay_back_button" class="c_back"></a>
      </div>
      <div class="c_title1">카드 등록 완료</div>
      <div class="c_result_icon m_b_20"><img src="${SDK_DOMAIN}/images/icon-success.png" /></div>
      <div class="c_label4_4 m_b_20 text_center">카드 등록이 완료되었습니다.</div>
      <div class="bottom_btn_wrapper">
          <button id="ok_btn" class="btn c_btn1 skin1_btn">확인</button>
      </div>
    `;
  },
  afterRender: async () => {
    const locationPath = getLocationPath();

    setAddEventListener('ok_btn', () => {
      window.parent.location.replace(`${locationPath}#close`);
    });
    setAddEventListener('connect_pay_back_button', () => {
      window.parent.location.replace(`${locationPath}#close`);
    });
  },
};
export default CardRegiComplete;
